export default __webpack_public_path__ + "static/Vyhledavac-4d0ddae2c7deba55147798365e6acf4f.svg";